/**
 * 判断是否为dom object
 */
const isDom = (typeof HTMLElement === 'object') ?
  function (obj) {
    return obj instanceof HTMLElement
  } :
  function (obj) {
    return obj && typeof obj === 'object' && obj.nodeType === 1 && typeof obj.nodeName === 'string'
  }

/**
 * 滚动条在Y轴上的滚动距离
 * @returns {number}
 */
export const getScrollTop = function () {
  let scrollTop = 0,
    bodyScrollTop = 0,
    documentScrollTop = 0
  if (document.body) {
    bodyScrollTop = document.body.scrollTop
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop
  }
  scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
  return scrollTop
}
/**
 * 文档的总高度
 * @returns {number}
 */
export const getScrollHeight = function () {
  let scrollHeight = 0,
    bodyScrollHeight = 0,
    documentScrollHeight = 0
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight
  }
  scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
  return scrollHeight
}
/**
 * 浏览器视口的高度
 * @returns {number}
 */
export const getWindowHeight = function () {
  let windowHeight = 0
  if (document.compatMode === 'CSS1Compat') {
    windowHeight = document.documentElement.clientHeight
  } else {
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

export const getWindowWidth = function () {
  let windowWidth = 0
  if (document.compatMode === 'CSS1Compat') {
    windowWidth = document.documentElement.clientWidth
  } else {
    windowWidth = document.body.clientWidth
  }
  return windowWidth
}

export default {
  getScrollTop,
  getScrollHeight,
  getWindowHeight,
  getWindowWidth
}



// WEBPACK FOOTER //
// ./src/common/util/dom.js